import React from "react";
import APIS from "../../constant/EndPoint";
import TextField from "../Reusable/TextField";
import NumberField from "../Reusable/NumberField";
import ComboboxInput from "../Reusable/ComboboxInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import PhoneNumberField from "../Reusable/PhoneNumberField";
const WarehosueForm = ({
  register,
  errors,
  setValue,
  getValues,
  control,
  clearErrors,
}: any) => {
  return (
    <>
      <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
        <TextField
          label={"Warehosue Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <TextField
          label={"Primary Email"}
          register={register("primary_email")}
          errors={errors?.primary_email}
        />
      </div>

      <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
        <PhoneNumberField
          control={control}
          label={"Primary Contact"}
          name={"primary_contact"}
          errors={errors?.primary_contact}
        />
        <PhoneNumberField
          control={control}
          label={"Secondary Contact"}
          name={"secondary_contact"}
          errors={errors?.secondary_contact}
        />
      </div>
      <div className={tw`w-full font-semibold mt-2 text-left mx-4`}>
        <p>Address</p>
      </div>
      <div className={tw`grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
        <ComboboxInput
          label={"Country"}
          placeholder={"Search Country"}
          url={APIS.LOCATION_LIST}
          props={{ level: 0, is_ative: true }}
          queryKey={"country"}
          register={register("country")}
          errors={errors?.country}
          name={"country"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"State"}
          placeholder={"State"}
          url={APIS.LOCATION_LIST}
          props={{ level: 1, is_active: true, parent: getValues("country") }}
          queryKey={`state-${getValues("country")}`}
          register={register("state")}
          errors={errors?.state}
          name={"state"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"District"}
          placeholder={"District"}
          url={APIS.LOCATION_LIST}
          props={{ level: 2, is_active: true, parent: getValues("state") }}
          queryKey={`district-${getValues("state")}`}
          register={register("district")}
          errors={errors?.district}
          name={"district"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          label={"City"}
          placeholder={`City`}
          url={APIS.LOCATION_LIST}
          props={{ level: 3, is_active: true, parent: getValues("district") }}
          queryKey={`city-${getValues("district")}`}
          register={register("city")}
          errors={errors?.city}
          name={"city"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <TextField
          label={"Landmark"}
          register={register("landmark")}
          errors={errors?.landmark}
        />
        <ComboboxInput
          label={"Warehouse Manager"}
          placeholder={"Warehouse Manager"}
          url={APIS.USER}
          queryKey={"staff"}
          props={{
            is_active: true,
            is_staff: true,
          }}
          register={register("manager")}
          errors={errors?.manager}
          name={"manager"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
    </>
  );
};

export default WarehosueForm;
